import Alert, {AlertType} from 'features/POSRegisters/interfaces/AlertInfo';
import {SeverityPriorityEnum} from 'features/POSRegisters/interfaces/Severity';
import DeviceType from '../interfaces/DeviceType';
import {convertKeysToCamelCase} from 'utils/utils';

function apiAlertToNposAlert(alerts: Alert[], deviceType: DeviceType) {
  const filteredAlerts = alerts.filter(
    (alert): alert is Alert =>
      alert !== null &&
      alert !== undefined &&
      typeof alert === 'object' &&
      'alertType' in alert &&
      'siteImpact' in alert
  );
  const normalizedDeviceAlerts = filteredAlerts.map(alert => {
    if (alert.alertType === 'ScanFailureAlert') {
      return {
        ...convertKeysToCamelCase(alert),
        deviceType: deviceType,
        alertType: AlertType.SCAN_FAILURE_ALERT,
        priority: SeverityPriorityEnum.SCANFAILURE,
      };
    } else if (alert.alertType === 'OrphanDeviceAlert') {
      return {
        ...convertKeysToCamelCase(alert),
        deviceType: deviceType,
        alertType: AlertType.ORPHAN_DEVICE_ALERT,
        priority: SeverityPriorityEnum.ORPHAN,
      };
    } else if (alert.alertType === 'ConfigurationAlert') {
      return {
        ...convertKeysToCamelCase(alert),
        deviceType: deviceType,
        alertType: AlertType.CONFIGURATION_ALERT,
        priority: SeverityPriorityEnum.ORPHAN,
      };
    } else {
      const siteImpact = alert.siteImpact.toUpperCase();
      return {
        ...convertKeysToCamelCase(alert),
        deviceType: deviceType,
        alertType: AlertType.DIAGNOSTIC_ALERT,
        priority: SeverityPriorityEnum[siteImpact],
      };
    }
  });

  return normalizedDeviceAlerts as Alert[];
}

export default apiAlertToNposAlert;
